import PropTypes from 'prop-types';
import React from 'react';

export const SmartHandlerButton = props => {
  let clicked = false;

  function onClick(event) {
    if (clicked) {
      return;
    }

    clicked = true;
    setTimeout(() => {
      clicked = false;
    }, 3000);

    if (props.onClick) {
      props.onClick(event);
    }
  }
  const buttonProps = {
    id: props.id,
    className: props.className,
    disabled: props.disabled,
    onClick
  };

  return <button {...buttonProps}>{props.children}</button>;
};

SmartHandlerButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.any,
  disabled: PropTypes.bool,
  id: PropTypes.string
};

export default SmartHandlerButton;
